import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import {
  CaseTemplate,
  CaseTemplateBasicsOption,
  CaseTemplateStatus,
} from 'dashboard/models/case-template';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export type CaseTemplatesActions =
  | Action<CaseTemplatesActionType.SetCaseTemplates, SetCaseTemplatesPayload>
  | Action<CaseTemplatesActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<CaseTemplatesActionType.SetPageSize, SetPageSizePayload>
  | Action<CaseTemplatesActionType.SetFilters, SetFiltersPayload>
  | Action<CaseTemplatesActionType.SetBasicsOptions, SetBasicsOptionsPayload>
  | Action<CaseTemplatesActionType.SetSortParams, SetSortParamsPayload>;

export enum CaseTemplatesActionType {
  SetCaseTemplates = 'case-templates/SET_CASE_TEMPLATES',
  SetCurrentPage = 'case-templates/SET_CURRENT_PAGE',
  SetPageSize = 'case-templates/SET_PAGE_SIZE',
  SetFilters = 'case-templates/SET_FILTERS',
  SetBasicsOptions = 'case-templates/SET_BASICS_OPTIONS',
  SetSortParams = 'case-templates/SET_SORT_PARAMS',
}

interface SetCaseTemplatesPayload {
  caseTemplates: CaseTemplate[];
  paginationParams: PaginationParams;
  atActiveCaseTemplateLimit: boolean;
}

export function setCaseTemplates(
  caseTemplates: CaseTemplate[],
  paginationParams: PaginationParams,
  atActiveCaseTemplateLimit: boolean,
): Action<CaseTemplatesActionType.SetCaseTemplates, SetCaseTemplatesPayload> {
  return {
    payload: {
      caseTemplates,
      paginationParams,
      atActiveCaseTemplateLimit,
    },
    type: CaseTemplatesActionType.SetCaseTemplates,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<CaseTemplatesActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: CaseTemplatesActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<CaseTemplatesActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: CaseTemplatesActionType.SetPageSize,
  };
}

export interface CaseTemplatesFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  status?: CaseTemplateStatus[];
  omni?: string;
  caseTemplateIds?: string[];
}

interface SetFiltersPayload {
  filters: CaseTemplatesFilterParams;
}

export function setFilters(
  filters: CaseTemplatesFilterParams,
): Action<CaseTemplatesActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: CaseTemplatesActionType.SetFilters,
  };
}

interface SetBasicsOptionsPayload {
  basicsOptions: CaseTemplateBasicsOption[];
}

export function setCaseTemplateBasicsOptions(
  basicsOptions: SetBasicsOptionsPayload['basicsOptions'],
): Action<CaseTemplatesActionType.SetBasicsOptions, SetBasicsOptionsPayload> {
  return {
    payload: {
      basicsOptions,
    },
    type: CaseTemplatesActionType.SetBasicsOptions,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<CaseTemplatesActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: CaseTemplatesActionType.SetSortParams,
  };
}
